import * as React from 'react';

import GlobalLoadingContext from './context';

const GlobalLoaderProvider: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [globalLoading, setGlobalLoading] = React.useState(false);
  return (
    <GlobalLoadingContext.Provider value={{ globalLoading, setGlobalLoading }}>
      {children}
    </GlobalLoadingContext.Provider>
  );
};

export default GlobalLoaderProvider;
